type FormatPercentOptions = { min?: number; max?: number };

export const formatPercent = (value: number, options?: FormatPercentOptions): string => {
  const min = options?.min ?? Number.NEGATIVE_INFINITY;
  const max = options?.max ?? Number.POSITIVE_INFINITY;
  const normalised = Math.min(max, Math.max(min, value));
  const fixed = normalised.toFixed(2);
  return fixed.replace(/\.?0+$/, '');
};
